import React, { useRef, useState } from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import { STATE_IDLE, STATE_LOADING } from '../../../redux/redux.constants';
import classes from './verification-loading-popup.scss';
const unsetTimeout = timeoutID => {
  if (timeoutID && timeoutID.current) {
    clearTimeout(timeoutID.current);
    timeoutID.current = null;
  }
};
const FIVE_HUNDRED_MILLISECONDS = 500;
const VerificationPopup = ({
  verifyState
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const timeoutID = useRef(null);
  if (verifyState === STATE_LOADING && !timeoutID.current) {
    timeoutID.current = setTimeout(() => setShowLoader(true), FIVE_HUNDRED_MILLISECONDS);
  } else if (verifyState !== STATE_LOADING && timeoutID.current) {
    unsetTimeout(timeoutID);
    setShowLoader(false);
  }
  if (verifyState === STATE_IDLE) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: showLoader,
    showCloseButton: false,
    content: /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("h2", null, "Please wait"), /*#__PURE__*/React.createElement("div", null, "We are verifying your email..."))
  });
};
export default VerificationPopup;